import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Console } from 'console';
import { SignalrService } from 'src/app/services/signalr.service';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit, OnDestroy {

  @ViewChild('localVideo') localVideo: ElementRef;
  //@ViewChild('remoteVideo') remoteVideo: ElementRef;
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  localStream: MediaStream;
  remoteStream: MediaStream;
  mixStream: MediaStream = new MediaStream(); // lokalni video in remote audio

  room: string;
  peerConnection: RTCPeerConnection;

  isInitiator: boolean;
  isChannelReady: boolean;
  isStarted: boolean;

  constructor(
    private snack: MatSnackBar,
    private route: ActivatedRoute,
    private signaling: SignalrService
  ) {
    this.route.paramMap.subscribe(async param => {
      this.room = param['params']['room'];
    });

    document.body.style.backgroundColor = 'black';
    document.body.style.overscrollBehaviorY = 'contain';

    
  }




 

  GEOLocationSuccess(pos): void {

    if (pos == null || pos.coords == null) {
      console.warn('GEOLocationSuccess je NULL!');
      return;
    }

    var crd = pos.coords;

  //  console.log('Your current position is:');
    console.log(`Latitude : ${crd.latitude}`);
    console.log(`Longitude: ${crd.longitude}`);
    console.log(`More or less ${crd.accuracy} meters.`);

   // this.sendMessage('KAJ');

   // this.sendMessage({ type: 'geolokacijaStranke'})
    this.sendMessage({ type: 'clientGEO', latitude: crd.latitude, longitude: crd.longitude, accuracy: crd.accuracy })
  }

  GEOLocationError(err): void {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }


  getMyGeolocation(): void {
    navigator.geolocation.getCurrentPosition(this.GEOLocationSuccess.bind(this), this.GEOLocationError.bind(this), {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    });
    //this.snack.open('GEOLocation', 'OK', { duration: 2000, verticalPosition: "top" });
  }

  drawCanvas(canvas, img): void {
    canvas.width = getComputedStyle(canvas).width.split('px')[0];
    canvas.height = getComputedStyle(canvas).height.split('px')[0];
    let ratio = Math.min(canvas.width / img.width, canvas.height / img.height);
    let x = (canvas.width - img.width * ratio) / 2;
    let y = (canvas.height - img.height * ratio) / 2;
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height,
      x, y, img.width * ratio, img.height * ratio);
  }
  
  fullScreen(): void {

    this.sendMessage("klik fullScreen");
    try {
      var elem = this.localVideo.nativeElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.webkitEnterFullScreen) {
        elem.webkitEnterFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }

      this.sendMessage("klik fullScreen konec");
    } catch (err) {
      this.sendMessage("napaka pri requestFullscreen = " + err.message)
    }
  }


  onGetUserMediaButtonClick(): void {
    console.log('klik');

   /* this.sendMessage("client this.localVideo.nativeElement = " + this.localVideo.nativeElement.muted);
    this.sendMessage("client this.remoteVideo.nativeElement = " + this.remoteVideo.nativeElement.muted);

    try {
      this.localVideo.nativeElement.muted = true;
      this.remoteVideo.nativeElement.muted = false;
      this.sendMessage("ninapake");

      this.sendMessage("client this.localVideo.nativeElement = " + this.localVideo.nativeElement.muted);
      this.sendMessage("client this.remoteVideo.nativeElement = " + this.remoteVideo.nativeElement.muted);

    } catch (err) {
      this.sendMessage("NAPAKA");
      this.sendMessage(err.message);
    }

    return;*/

   //var canvas = document.querySelector('#takePhotoCanvas');
    var context = this.canvas.nativeElement.getContext('2d');
    var video = document.querySelector('#localVideo');

    //console.log(this.localStream.getVideoTracks()[0].getCapabilities());

    let fr = this.localStream.getVideoTracks()[0].getSettings().frameRate;
    let height = this.localStream.getVideoTracks()[0].getSettings().height;
    let width = this.localStream.getVideoTracks()[0].getSettings().width;

    this.sendMessage("Video - fr = " + fr + " height=" + height + " width=" + width);
    let as = height / width;

    let newH = 200 * as;
    let newW = 200;

    console.log(as);

    console.log(newH);
    console.log(newW);



    this.canvas.nativeElement.width = width;
    this.canvas.nativeElement.height = height;
    context.drawImage(this.localVideo.nativeElement, 0, 0, width, height);
    console.log('ok');

    let imgUrl = this.canvas.nativeElement.toDataURL('image/jpeg', 1.0)
   // console.log(imgUrl.toString());
    
    //this.canvas.nativeElement.toBlob(async blob => {
    //    const base64Image = await fileToBase64(blob);
    //    resolve(base64Image);
    //  });

    //this.sendMessage({ type: 'myPic', imgUrl: '' });
    let app = this;
    let r = Math.floor(Math.random() * 100000).toString();
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {

      console.log("xhttp.responseText = " + this.responseText);
      app.sendMessage({ type: 'myPic', id: r });

    }
    xhttp.open("POST", environment.signalingServerUrl + "/uploadFile/" + this.room + "/" + r);
    //xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    xhttp.send(imgUrl);


   /* const track = this.localStream.getVideoTracks()[0];
    new ImageCapture(track).takePhoto()
      .then(blob => createImageBitmap(blob))
      .then(imageBitmap => {
        const canvas = document.querySelector('#takePhotoCanvas');
        console.log(canvas);
        this.drawCanvas(canvas, imageBitmap);
      })
      .catch(error => console.log(error));*/
  }


  ngOnInit(): void {

    //setTimeout(function () {
    //  // This hides the address bar:
    //  window.scrollTo(0, 1);
    //}, 2000);

    this.signaling.connect('/auth', false).then(() => {
      if (this.signaling.isConnected()) {
        this.signaling.invoke('Authorize').then((token: string) => {
          if (token) {
            sessionStorage.setItem('token', token);
            this.start();
          }
        });
      }
    });
    
  }

  start(): void {
    // #1 connect to signaling server
    this.signaling.connect('/signaling', true).then(() => {
      if (this.signaling.isConnected()) {
        this.signaling.invoke('CreateOrJoinRoom', this.room);
        this.sendMessage({ type: 'clientUserAgent', value: window.navigator.userAgent, volumen: this.localVideo.nativeElement.volume });
      }
    });

    // #2 define signaling communication
    this.defineSignaling();
    
    // #3 get media from current client
    this.getUserMedia();
  }

  defineSignaling(): void {
    this.signaling.define('log', (message: any) => {
      console.log(message);
    });

    this.signaling.define('created', () => {
      this.isInitiator = true;
    });

    this.signaling.define('joined', () => {
      this.isChannelReady = true;
    });

    this.signaling.define('banned', () => {
      if (this.isStarted) {
        this.stopPeerConnection();
        this.isInitiator = true;
        this.sendMessage("saj grem sej grem.");
        this.stopTracks();
      }
      else
        this.sendMessage("saj grem sej grem 2.");
    });

    this.signaling.define('message', (message: any) => {
      if (message === 'got user media') {
        this.initiateCall();

      } else if (message.type === 'offer') {
        if (!this.isStarted) {
          this.initiateCall();
        }
        this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));
        this.sendAnswer();

      } else if (message.type === 'answer' && this.isStarted) {
        this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));

      } else if (message.type === 'candidate' && this.isStarted) {
        this.addIceCandidate(message);

      } else if (message === 'bye' && this.isStarted) {
        this.handleRemoteHangup();

      } else if (message === 'getGeolocation') {
        this.getMyGeolocation();

      } else if (message === 'takePic') {
        this.onGetUserMediaButtonClick();
      }
      else if (message.type === 'changeCam') {
        this.changeUserMedia(message.deviceId, message.size);
      }
      else if (message.type === 'increaseClientVolume') {

        if (this.localVideo.nativeElement.volume + message.volValue > 1) {
          this.localVideo.nativeElement.volume = 1;
        }
        else {
          this.localVideo.nativeElement.volume = Math.round((this.localVideo.nativeElement.volume + message.volValue) * 100) / 100 ;
        }
        this.sendMessage({ type: 'clientVolume', volume: this.localVideo.nativeElement.volume, snackMessage: 'Glasnost stranke je ' + (Math.round(this.localVideo.nativeElement.volume * 100) / 100)*100 + '%' })

      }
      
    });
  }

  changeUserMedia(videoSource, size): void {

    if (this.localStream) {
      this.localStream.getVideoTracks().forEach(track => {
        track.stop();
      });

      
    }

    var videoSett = {}
    
    if (videoSource && videoSource !== '0' && size && size.width !== 0) {
      videoSett = { deviceId: { exact: videoSource }, width: size.width, height: size.height, };
    }
    else if (videoSource && videoSource !== '0') {
      videoSett = { deviceId: { exact: videoSource } };
    }
    else if (size && size.width !== 0) {
      videoSett = { facingMode: 'environment', width: size.width, height: size.height };
    }
    else {
      videoSett = { facingMode: 'environment' };
    }

    var constraints = {
      audio: true,
      video: videoSett
    };

    this.sendMessage('changeCam settings:');
    this.sendMessage(constraints);

    navigator.mediaDevices.getUserMedia(constraints)
      .then((stream: MediaStream) => {
        this.addLocalStream(stream);
       // this.localStream = stream;

        this.sendMessage('got user media2');

        //if (this.isInitiator) {
        //  this.initiateCall();
        //}

        for (var sender of this.peerConnection.getSenders()) {
          //if (sender.track.kind == "audio") {
          //  if (stream.getAudioTracks().length > 0) {
          //    sender.replaceTrack(stream.getAudioTracks()[0]);
          //  }
          //}
          if (sender.track.kind == "video") {
            if (stream.getVideoTracks().length > 0) {
              sender.replaceTrack(stream.getVideoTracks()[0]);
            }
          }
        }
        /*
        // Video 
        let videoTrack = stream.getVideoTracks()[0];
        var sender = this.peerConnection.getSenders().find(function (s) {
          return s.track.kind == videoTrack.kind;
        });
        console.log('found sender:', sender);
        sender.replaceTrack(videoTrack);

        //Audio
        let audioTrack = stream.getAudioTracks()[0];
        var sender = this.peerConnection.getSenders().find(function (s) {
          return s.track.kind == audioTrack.kind;
        });*/
        console.log('found sender:');
       // sender.replaceTrack(audioTrack);


      })
      .catch((e) => {
        this.sendMessage('getUserMedia() error: ' + e.name + ': ' + e.message);
      });
  }

  getUserMedia(): void {

    navigator.mediaDevices.getUserMedia({
      audio: true,
      video: {
        facingMode: 'environment',
        width: 640, height: 360
       // frameRate: { min: 6, max: 20 }
      }
    })
      .then((stream: MediaStream) => {
        this.addLocalStream(stream);
        this.sendMessage('got user media');
        this.sendMessage({ type: 'clientVolume', volume: this.localVideo.nativeElement.volume })
        if (this.isInitiator) {
          this.initiateCall();
        }
        return navigator.mediaDevices.enumerateDevices();
        // this.getDevices();
      }).then(this.gotDevices).then((devicesArr: []) => {
        this.sendMessage({ type: 'clientEnumerateDevices', devices: devicesArr })
      })
      .catch((e) => {
        this.sendMessage('getUserMedia() error: ' + e.name + ': ' + e.message);
      });
  }

  gotDevices(deviceInfos): [] {
    // AFAICT in Safari this only gets default devices until gUM is called :/
    let devicesArray = Array.apply(null, null).map(function () { return new Object(); });
    try {
      
      

      for (const deviceInfo of deviceInfos) {
        if (deviceInfo.kind === 'videoinput') {
          devicesArray.push({ label: deviceInfo.label, deviceId: deviceInfo.deviceId });
         // devicesString += deviceInfo.label + '|-|' + deviceInfo.deviceId + '|||';
        }
      }
      return devicesArray;
      

    } catch (e) {

      if (e && e.message) this.sendMessage('Failed to load enumerateDevices. ' + e.message);
      else this.sendMessage('Failed to load enumerateDevices. brez!');

      console.log('Failed to load enumerateDevices. ', e.message);

    }
  }

  initiateCall(): void {
    console.log('Initiating a call.');
    if (!this.isStarted && this.localStream && this.isChannelReady) {
      this.createPeerConnection();

      this.peerConnection.addTrack(this.localStream.getVideoTracks()[0], this.localStream);
      this.peerConnection.addTrack(this.localStream.getAudioTracks()[0], this.localStream);

      this.isStarted = true;
      if (this.isInitiator) {
        this.sendOffer();
      }
    }
  }

  createPeerConnection(): void {
    console.log('Creating peer connection.');
    try {
      this.peerConnection = new RTCPeerConnection({
        iceServers: environment.iceServers,
        sdpSemantics: 'unified-plan'
      } as RTCConfiguration);

      this.peerConnection.onicecandidate = (event: RTCPeerConnectionIceEvent) => {
        if (event.candidate) {
          this.sendIceCandidate(event);
        } else {
          console.log('End of candidates.');
        }
      };

      this.peerConnection.ontrack = (event: RTCTrackEvent) => {
        if (event.streams[0]) {
          this.addRemoteStream(event.streams[0]);
        }
      };
    } catch (e) {
      console.log('Failed to create PeerConnection.', e.message);
      return;
    }
  }

  sendOffer(): void {
    console.log('Sending offer to peer.');
    this.addTransceivers();
    this.peerConnection.createOffer()
    .then((sdp: RTCSessionDescriptionInit) => {
      this.peerConnection.setLocalDescription(sdp);
      this.sendMessage(sdp);
    });
  }

  sendAnswer(): void {
    console.log('Sending answer to peer.');
    this.addTransceivers();
    this.peerConnection.createAnswer().then((sdp: RTCSessionDescription) => {
      this.peerConnection.setLocalDescription(sdp);
      this.sendMessage(sdp);
    });
  }

  addIceCandidate(message: any): void {
    console.log('Adding ice candidate.');
    const candidate = new RTCIceCandidate({
      sdpMLineIndex: message.label,
      candidate: message.candidate
    });
    this.peerConnection.addIceCandidate(candidate);
  }

  sendIceCandidate(event: RTCPeerConnectionIceEvent): void {
    console.log('Sending ice candidate to remote peer.');
    this.sendMessage({
      type: 'candidate',
      label: event.candidate.sdpMLineIndex,
      id: event.candidate.sdpMid,
      candidate: event.candidate.candidate
    });
  }

  sendMessage(message): void {
    this.signaling.invoke('SendMessage', message, this.room);
  }

  addTransceivers(): void {
    console.log('Adding transceivers.');
    const init = { direction: 'recvonly', streams: [], sendEncodings: [] } as RTCRtpTransceiverInit;
    this.peerConnection.addTransceiver('audio', init);
    this.peerConnection.addTransceiver('video', init);
  }

  addLocalStream(stream: MediaStream): void {
    console.log('Local stream added.');
    this.localStream = stream;

    var vTracks = this.mixStream.getVideoTracks();
    //var vTracks = this.mixStream.getTracks();

    if (vTracks.length > 0) {
      vTracks.forEach((track) => { track.stop(); });
      this.mixStream.removeTrack(vTracks[0]);
    }
    this.mixStream.addTrack(stream.getVideoTracks()[0]);

    this.localVideo.nativeElement.srcObject = this.mixStream;
  // this.localVideo.nativeElement.muted = 'muted';

    
  }

  addRemoteStream(stream: MediaStream): void {
    console.log('Remote stream added.');
    this.remoteStream = stream;
  //  this.remoteVideo.nativeElement.srcObject = this.remoteStream;
  //  this.remoteVideo.nativeElement.muted = 'muted';
    const aTracks = this.mixStream.getAudioTracks();
    
    if (aTracks.length > 0) {
      aTracks.forEach((track) => { track.stop(); });
      this.mixStream.removeTrack(aTracks[0]);
    }
    this.mixStream.addTrack(stream.getAudioTracks()[0]);

    this.localVideo.nativeElement.srcObject = this.mixStream;

  }

  hangup(): void {
    console.log('Hanging up.');
    this.stopPeerConnection();
    this.sendMessage('bye');
    this.signaling.invoke('LeaveRoom', this.room);
    setTimeout(() => {
      this.signaling.disconnect();
    }, 1000);
  }

  handleRemoteHangup(): void {
    console.log('Session terminated by remote peer.');
    this.stopPeerConnection();
    this.isInitiator = true;
    this.stopTracks();
    this.snack.open('Konec video ogleda, lahko zaprete brskalnik.', 'konec', { verticalPosition: "top" });
    setTimeout(() => {
      this.signaling.disconnect();
    }, 1000);
  }

  stopPeerConnection(): void {
    this.isStarted = false;
    this.isChannelReady = false;
    if (this.peerConnection) {
      this.peerConnection.close();
      this.peerConnection = null;
    }
  }

  ngOnDestroy(): void {
    this.hangup();
    this.stopTracks();
  }
  stopTracks(): void {
    if (this.localStream && this.localStream.active) {
      this.localStream.getTracks().forEach((track) => { track.stop(); });
    }
    if (this.remoteStream && this.remoteStream.active) {
      this.remoteStream.getTracks().forEach((track) => { track.stop(); });
    }
  }
}
